import {Injectable} from "@angular/core";
import {FormBuilderTypeSafe, FormGroupTypeSafe} from "angular-typesafe-reactive-forms-helper";
import {PrikazRabataFormService} from "../../common/prikaz-rabata-form.service";
import {VelicinaPapiraFormService} from "../../common/velicina-papira-form-service";
import {IOpstaPravilaFiskalniDto} from "@kodit/core/data-api";
import { FormControl } from '@angular/forms';
import { PostAkcijaFiskalizacijaFormService } from '../../common/post-akcija-fiskalizacija-form-.service';

@Injectable({
  providedIn: 'root',
})

export class OpstaPravilaFiskalnaFormService {

  constructor(
    private _fb: FormBuilderTypeSafe,
    private _velicinaPapiraFS: VelicinaPapiraFormService,
    private _prikazPopustaService: PrikazRabataFormService,
    private _fiskalPostService: PostAkcijaFiskalizacijaFormService
  ) {
  }


  public GetOpstaPravilaFiskalnaFormGroup(
    model?: IOpstaPravilaFiskalniDto
  ): FormGroupTypeSafe<IOpstaPravilaFiskalniDto> {
    return this._fb.group<IOpstaPravilaFiskalniDto>({
      velicinaPapiraDto: this._velicinaPapiraFS.GetVelicinaPapiraFormGroup(
        model?.velicinaPapiraDto
      ),
      prikazRabataDto: this._prikazPopustaService.GetPrikazRabataFormGroup(
        model?.prikazRabataDto
      ),
      barkodSkener: new FormControl(model?.barkodSkener),
      stampanje: new FormControl(model?.stampanje),
      postFiskalizacijeAkcijaDto: this._fiskalPostService.GetPostakcijaFisakalizacijaForm(
        model?.postFiskalizacijeAkcijaDto
      )
    });
  }
}
